
import orderConstants from '../constants/orderConstants';
import { contractTypes } from '../constants/indentConstants';

export const isContract = type =>
  type && type === orderConstants.CONTRACT;

export const isOpen = type =>
  type && type === orderConstants.OPEN;

export const isNoFreight = type =>
  type && type === orderConstants.NO_FREIGHT;

export const isMarket = type =>
  type && type === orderConstants.MARKET;

export const getContractType = contractType =>
  contractTypes[contractType - 1] && contractTypes[contractType - 1].name;
